/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportPublicHolidaysRequest
 */
export interface ImportPublicHolidaysRequest {
    /**
     * 
     * @type {number}
     * @memberof ImportPublicHolidaysRequest
     */
    fromYear: number;
    /**
     * 
     * @type {number}
     * @memberof ImportPublicHolidaysRequest
     */
    tillYear: number;
}

/**
 * Check if a given object implements the ImportPublicHolidaysRequest interface.
 */
export function instanceOfImportPublicHolidaysRequest(value: object): value is ImportPublicHolidaysRequest {
    if (!('fromYear' in value) || value['fromYear'] === undefined) return false;
    if (!('tillYear' in value) || value['tillYear'] === undefined) return false;
    return true;
}

export function ImportPublicHolidaysRequestFromJSON(json: any): ImportPublicHolidaysRequest {
    return ImportPublicHolidaysRequestFromJSONTyped(json, false);
}

export function ImportPublicHolidaysRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportPublicHolidaysRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fromYear': json['fromYear'],
        'tillYear': json['tillYear'],
    };
}

export function ImportPublicHolidaysRequestToJSON(json: any): ImportPublicHolidaysRequest {
    return ImportPublicHolidaysRequestToJSONTyped(json, false);
}

export function ImportPublicHolidaysRequestToJSONTyped(value?: ImportPublicHolidaysRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromYear': value['fromYear'],
        'tillYear': value['tillYear'],
    };
}

